// src/context/UIContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";

/* =========================
   Types
========================= */

export type ViewMode =
  | "project-chat"
  | "issue-chat"
  | "issue-details"
  | "project-dashboard"
  | "project-reports"
  | "project-gantt"
  | "material-statement"
  | "dpr-report"        // ✅ ADD THIS
  | "drs-notes-report"
 
  | "dpr-cumulative"
 
     | "works-progress-report"   // ✅ ADD THIS
     | "group-report"  // ✅ ADD THIS
     | "markwise-progress"  // ✅ ADD THIS
  | "material-statement"  // ✅ MUST EXIST
  | "material-statement-vendor-wise"
  | "manpower-statement-vendor-wise"
  | "manpower-statement-resource-wise"
  | "equipment-statement-resource-wise"
  | "drawings-report"   // ✅ ADD THIS
  | "equipment-statement-vendor-wise"
  | "weather-keyword-report"
  | "task-report"
  //| "superadmin"
  | "all-issues";
  
 // | "material-statement";


type UIStateSnapshot = {
  selectedProjectId: number | null;
  selectedProjectName: string | null;
  selectedIssueId: number | null;
  selectedIssueTitle: string | null;
  viewMode: ViewMode;
  allIssuesFilters: {
    status: string;
    taskGroup: string;
    fromDue: string;
    toDue: string;
  };
  ganttAsOnDate: string | null;
};

type UIContextType = {
  selectedProjectId: number | null;
  setSelectedProjectId: (id: number | null) => void;

  selectedProjectName: string | null;
  setSelectedProjectName: (name: string | null) => void;

  selectedIssueId: number | null;
  setSelectedIssueId: (id: number | null) => void;

  selectedIssueTitle: string | null;
  setSelectedIssueTitle: (t: string | null) => void;

  viewMode: ViewMode;
  setViewMode: React.Dispatch<React.SetStateAction<ViewMode>>;

  allIssuesFilters: {
    status: string;
    taskGroup: string;
    fromDue: string;
    toDue: string;
  };
  setAllIssuesFilters: React.Dispatch<
    React.SetStateAction<{
      status: string;
      taskGroup: string;
      fromDue: string;
      toDue: string;
    }>
  >;

  ganttAsOnDate: string | null;
  setGanttAsOnDate: (d: string | null) => void;

  pushUIState: () => void;
  popUIState: () => void;

  isRestored: boolean;
  resetUI: () => void;
};

/* =========================
   Context
========================= */

const UIContext = createContext<UIContextType | undefined>(undefined);

/* =========================
   Helpers
========================= */

const getUIStateKey = (userNo?: number) =>
  userNo ? `ui-state-${userNo}` : null;

/* =========================
   Provider
========================= */

export const UIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, initialized } = useAuth();

  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
  const [selectedProjectName, setSelectedProjectName] = useState<string | null>(null);
  const [selectedIssueId, setSelectedIssueId] = useState<number | null>(null);
  const [selectedIssueTitle, setSelectedIssueTitle] = useState<string | null>(null);
  const [viewMode, setViewMode] = useState<ViewMode>("project-chat");

  const [allIssuesFilters, setAllIssuesFilters] = useState({
    status: "",
    taskGroup: "",
    fromDue: "",
    toDue: "",
  });

  const [ganttAsOnDate, setGanttAsOnDate] = useState<string | null>(null);
  const [uiHistory, setUiHistory] = useState<UIStateSnapshot[]>([]);
  const [isRestored, setIsRestored] = useState(false);

  /* =========================
     Restore UI State (SAFE)
  ========================= */
//correct final before
/*useEffect(() => {
    if (!initialized) return;

    if (!user?.userNo) {
      setIsRestored(true);
      return;
    }

    const key = getUIStateKey(user.userNo);
    const saved = key ? localStorage.getItem(key) : null;

    if (saved) {
      try {
        const parsed: UIStateSnapshot = JSON.parse(saved);

        setSelectedProjectId(parsed.selectedProjectId ?? null);
        setSelectedProjectName(parsed.selectedProjectName ?? null);
        setSelectedIssueId(parsed.selectedIssueId ?? null);
        setSelectedIssueTitle(parsed.selectedIssueTitle ?? null);
        setViewMode(parsed.viewMode ?? "project-chat");
        setAllIssuesFilters(parsed.allIssuesFilters);
        setGanttAsOnDate(parsed.ganttAsOnDate ?? null);
      } catch (err) {
        console.error("Failed to restore UI state", err);
      }
    }

    setIsRestored(true);
  }, [initialized, user?.userNo]);*/


//CORRECT BEFORE
  /*useEffect(() => {
  if (!initialized) return;

  // Always reset navigation on refresh
  setSelectedProjectId(null);
  setSelectedProjectName(null);
  setSelectedIssueId(null);
  setSelectedIssueTitle(null);
  setViewMode("project-chat");

  if (!user?.userNo) {
    setIsRestored(true);
    return;
  }

  const key = getUIStateKey(user.userNo);
  const saved = key ? localStorage.getItem(key) : null;

  if (saved) {
    try {
      const parsed: UIStateSnapshot = JSON.parse(saved);

      // Restore only safe preferences
      setAllIssuesFilters(parsed.allIssuesFilters);
      setGanttAsOnDate(parsed.ganttAsOnDate ?? null);
    } catch (err) {
      console.error("Failed to restore UI state", err);
    }
  }

  setIsRestored(true);
}, [initialized, user?.userNo]);*/

useEffect(() => {
  if (!initialized) return;

  if (!user?.userNo) {
    setIsRestored(true);
    return;
  }

  const key = getUIStateKey(user.userNo);
  const saved = key ? localStorage.getItem(key) : null;

  if (saved) {
    try {
      const parsed: UIStateSnapshot = JSON.parse(saved);

      // Restore ONLY safe UI preferences (not navigation)
      setAllIssuesFilters(parsed.allIssuesFilters);
      setGanttAsOnDate(parsed.ganttAsOnDate ?? null);

    } catch (err) {
      console.error("Failed to restore UI state", err);
    }
  }

  setIsRestored(true);
}, [initialized, user?.userNo]);




 /* useEffect(() => {
  if (!initialized) return;

  // ALWAYS start from project list
  setSelectedProjectId(null);
  setSelectedProjectName(null);
  setSelectedIssueId(null);
  setSelectedIssueTitle(null);
  setViewMode("project-chat");

  if (!user?.userNo) {
    setIsRestored(true);
    return;
  }

  const key = getUIStateKey(user.userNo);
  const saved = key ? localStorage.getItem(key) : null;

  if (saved) {
    try {
      const parsed: UIStateSnapshot = JSON.parse(saved);

      // ✅ restore ONLY safe preferences
      setAllIssuesFilters(parsed.allIssuesFilters);
      setGanttAsOnDate(parsed.ganttAsOnDate ?? null);
    } catch (err) {
      console.error("Failed to restore UI state", err);
    }
  }

  setIsRestored(true);
}, [initialized, user?.userNo]);*/


  /* =========================
     Save UI State (SAFE)
  ========================= */

  useEffect(() => {
    if (!initialized || !isRestored || !user?.userNo) return;

    const snapshot: UIStateSnapshot = {
      selectedProjectId,
      selectedProjectName,
      selectedIssueId,
      selectedIssueTitle,
      viewMode,
      allIssuesFilters,
      ganttAsOnDate,
    };

    localStorage.setItem(
      getUIStateKey(user.userNo)!,
      JSON.stringify(snapshot)
    );
  }, [
    initialized,
    isRestored,
    user?.userNo,
    selectedProjectId,
    selectedProjectName,
    selectedIssueId,
    selectedIssueTitle,
    viewMode,
    allIssuesFilters,
    ganttAsOnDate,
  ]);

  /* =========================
     History (Back Navigation)
  ========================= */

  const pushUIState = () => {
    setUiHistory((prev) => {
      const last = prev[prev.length - 1];
      if (
        last &&
        last.selectedProjectId === selectedProjectId &&
        last.selectedIssueId === selectedIssueId &&
        last.viewMode === viewMode &&
        last.ganttAsOnDate === ganttAsOnDate &&
        JSON.stringify(last.allIssuesFilters) ===
          JSON.stringify(allIssuesFilters)
      ) {
        return prev;
      }

      return [
        ...prev,
        {
          selectedProjectId,
          selectedProjectName,
          selectedIssueId,
          selectedIssueTitle,
          viewMode,
          allIssuesFilters,
          ganttAsOnDate,
        },
      ];
    });
  };

  //correct code
  /*
  const popUIState = () => {
    setUiHistory((prev) => {
      if (prev.length === 0) return prev;

      const last = prev[prev.length - 1];

      setSelectedProjectId(last.selectedProjectId);
      setSelectedProjectName(last.selectedProjectName);
      setSelectedIssueId(last.selectedIssueId);
      setSelectedIssueTitle(last.selectedIssueTitle);
      setViewMode(last.viewMode);
      setAllIssuesFilters(last.allIssuesFilters);
      setGanttAsOnDate(last.ganttAsOnDate);

      return prev.slice(0, -1);
    });
  };*/

  const popUIState = () => {
  setUiHistory((prev) => {
    if (prev.length === 0) {
      // Fallback behavior
      setSelectedIssueId(null);
      setSelectedIssueTitle(null);
      setViewMode("project-chat");
      return prev;
    }

    const last = prev[prev.length - 1];

    setSelectedProjectId(last.selectedProjectId);
    setSelectedProjectName(last.selectedProjectName);
    setSelectedIssueId(last.selectedIssueId);
    setSelectedIssueTitle(last.selectedIssueTitle);
    setViewMode(last.viewMode);
    setAllIssuesFilters(last.allIssuesFilters);
    setGanttAsOnDate(last.ganttAsOnDate);

    return prev.slice(0, -1);
  });
};


  /* =========================
     Reset (Logout Safe)
  ========================= */

  const resetUI = () => {
    if (user?.userNo) {
      localStorage.removeItem(getUIStateKey(user.userNo)!);
    }

    setSelectedProjectId(null);
    setSelectedProjectName(null);
    setSelectedIssueId(null);
    setSelectedIssueTitle(null);
    setViewMode("project-chat");

    setAllIssuesFilters({
      status: "",
      taskGroup: "",
      fromDue: "",
      toDue: "",
    });

    setGanttAsOnDate(null);
    setUiHistory([]);
  };

  /* =========================
     Provider
  ========================= */

  return (
    <UIContext.Provider
      value={{
        selectedProjectId,
        setSelectedProjectId,
        selectedProjectName,
        setSelectedProjectName,
        selectedIssueId,
        setSelectedIssueId,
        selectedIssueTitle,
        setSelectedIssueTitle,
        viewMode,
        setViewMode,
        allIssuesFilters,
        setAllIssuesFilters,
        ganttAsOnDate,
        setGanttAsOnDate,
        pushUIState,
        popUIState,
        isRestored,
        resetUI,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

/* =========================
   Hook
========================= */

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be used within UIProvider");
  return ctx;
}
